import React from 'react';

const processSteps = [
  {
    stepNumber: '01',
    stepLabel: 'Step: 01',
    title: 'Concept Generation',
    description:
      'Our logo design agency starts with a creative design, and we help you select a design that represents your brand identity and offerings. Our logo designers collaborate with you to come up with an idea that tells your brand message instantly to anyone.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 18h6" />
        <path d="M10 22h4" />
        <path d="M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7z" />
      </svg>
    )
  },
  {
    stepNumber: '02',
    stepLabel: 'Step: 02',
    title: 'Research',
    description:
      'We investigate and study the behavior of your audience and their taste so that we can add appealing and attractive elements to our design. To attract potential customers, we must know what things influence them and can lead to conversions.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <path d="M11 8a3 3 0 0 0-3 3" />
      </svg>
    )
  },
  {
    stepNumber: '03',
    stepLabel: 'Step: 03',
    title: 'Creativity',
    description:
      'We combine your brand’s essence with research insights in a creative way. We improve all aspects of your design with our innovative strategies. We explore multiple design versions until we discover the perfect match.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 19l7-7 3 3-7 7-3-3z" />
        <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
        <path d="M2 2l7.586 7.586" />
        <circle cx="11" cy="11" r="2" />
      </svg>
    )
  },
  {
    stepNumber: '04',
    stepLabel: 'Step: 04',
    title: 'Application',
    description:
      'In the last step, we implement all the creativity and best practices that we’ve researched to drive the best logo design at all touchpoints. We provide logo designs in multiple formats and sizes, ensuring seamless and hassle-free adjustments across all platforms, whether for web, print, or merchandise, so your brand always looks its best.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
        <polyline points="7 9 10 12 17 5" />
      </svg>
    )
  }
];

function LogoDesignProcess() {
  return (
    <section className="logo-process-section">
      <div className="container">
        {/* Section Header */}
        <div className="logo-process-header">
          <div className="logo-process-badge-row">
            <span className="logo-process-badge">Our Proven Methodology</span>
            <div className="logo-process-badge-line"></div>
          </div>
          <h2 className="logo-process-title">
            Our 4-Step Process to <span className="text-red">Crafting Iconic Logos</span>
          </h2>
          <p className="logo-process-subtitle">
            We follow a disciplined, research-backed creative framework to deliver visual identities that captivate audiences and stand the test of time.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="logo-process-grid">
          {processSteps.map((step, index) => (
            <div key={index} className="logo-process-card">
              {/* Card Header: Step Tag & Icon */}
              <div className="logo-process-card-top">
                <span className="logo-process-step-tag">{step.stepLabel}</span>
                <div className="logo-process-icon-box">
                  {step.icon}
                </div>
              </div>

              {/* Step Title */}
              <h3 className="logo-process-card-title">{step.title}</h3>

              {/* Accent Line */}
              <div className="logo-process-card-divider"></div>

              {/* Description */}
              <p className="logo-process-card-desc">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LogoDesignProcess;
